export default {
  "menu": {
    "activity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actividad"])}
  }
}